export default {
  en: {
    AUTH_MODAL_TITLE: 'Confirm your authentication',
    CONFIRM_BUTTON: 'Confirm',
    MULTI_FACTOR_AUTH_TT: 'Use the code from your authentication app to verify your identity',
    INPUT_MULTI_FACTOR_CODE: 'MFA Code',
    INPUT_MULTI_FACTOR_CODE_ERROR: 'Invalid code',
    INPUT_EMAIL: 'Email Address',
    INPUT_EMAIL_ERROR_DESCRIPTION: 'Please enter a valid email address',
    INPUT_PASSWORD: 'Password',
    REQUIRED_LABEL: 'Required',
  }
};